// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__393zM","plus":"Card_plus__1aTpd","favorite":"Card_favorite__2phsA"};